import { Injectable } from '@angular/core';

import { BaseService } from '../abstracts/base.service';
import { ClassroomModel } from '../models/classroom.model';
import { ResultModel } from '../models/result.model';
import { ClassLevelModel } from '../models/classlevel.model';
import { QuestionModel } from '../models/question.model';
import { QuestionMessageModel } from '../models/question-message.model';
@Injectable({
  providedIn: 'root'
})
export class QuestionService extends BaseService {


  listAllQuestions(formData: FormData) {
    return this.httpClient.post<ResultModel<QuestionModel[]>>(this.getApiUrl(`questions`), formData);
  }

  createQuestion(question: QuestionModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`questions/add`), question);
  }

  createMessage(questionID: string, questionMessage: QuestionMessageModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`questions/${questionID}/messages`), questionMessage);
  }

  createAudioMessage(questionID: string, file: File | Blob, fileName: string) {
    const questionMessage = new FormData();
    questionMessage.append('AudioFile', file, fileName);
    return this.httpClient.post<ResultModel>(this.getApiUrl(`questions/${questionID}/audio-message`), questionMessage);
  }

  getQuestion(questionID: string) {
    return this.httpClient.get<ResultModel<QuestionModel>>(this.getApiUrl(`questions/${questionID}`));
  }

  getQuestionMessages(questionID: string) {
    return this.httpClient.get<ResultModel<QuestionMessageModel[]>>(this.getApiUrl(`questions/${questionID}/messages`));
  }

  delete(questionID: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl(`questions/${questionID}`));
  }

  deleteMessage(questionID, questionMessageID) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl(`questions/${questionID}/messages/${questionMessageID}`));
  }

  updateQuestion(questionModel: QuestionModel) {
    return this.httpClient.put<ResultModel>(this.getApiUrl(`questions/update`), questionModel);
  }

  updateQuestionStatus(questionID: string) {
    return this.httpClient.post<ResultModel>(this.getApiUrl(`questions/${questionID}/update-status`), {});
  }

  handover(formData: any) {
    if (formData.AfterInstructorID) {
      return this.httpClient.post<ResultModel>(this.getApiUrl(`questions/before/${formData.BeforeInstructorID}/iswhohandover/${formData.IsWhoHandOver}/after/${formData.AfterInstructorID}`), {});
    }
    else {
      return this.httpClient.post<ResultModel>(this.getApiUrl(`questions/before/${formData.BeforeInstructorID}/iswhohandover/${formData.IsWhoHandOver}/after/`), {});
    }
  }

}
